"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fixture = void 0;
var enums_1 = require("../../enums");
var Base_1 = require("../Base");
// tslint:disable-next-line:interface-name
var Fixture = /** @class */ (function (_super) {
    __extends(Fixture, _super);
    function Fixture() {
        var _this = _super.call(this) || this;
        _this.status = enums_1.FixtureStatus.Active;
        return _this;
    }
    return Fixture;
}(Base_1.BaseModel));
exports.Fixture = Fixture;
//# sourceMappingURL=Fixture.js.map